module.exports = __webpack_public_path__ + "img/ask-luca-ai.e06163d0.png";